var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/service/pencil-circle",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,4.13400675 11.8659932,1 8,1 Z M10.8197913,3.20923202 L10.91405,3.29223316 L12.70705,5.08523316 C13.0671787,5.44580524 13.0948809,6.01274102 12.7901566,6.40506137 L12.70705,6.49928316 L7.20705,11.9992832 L4,11.9992832 L4,8.79223316 L9.5,3.29223316 C9.86076116,2.93256158 10.4273624,2.90489453 10.8197913,3.20923202 Z M7.99965,6.20598316 L5,9.20633316 L5,10.9992832 L6.79295,10.9992832 L9.79295,7.99928316 L7.99965,6.20598316 Z M10.20655,3.99878316 L8.70665,5.49888316 L10.5,7.29223316 L12,5.79223316 L10.20655,3.99878316 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilCircle);
export default __webpack_public_path__ + "static/media/pencil-circle.2320a9e203402f04ed31ae45322ac006.svg";
export { ForwardRef as ReactComponent };